import { render, staticRenderFns } from "./RuleHistory.vue?vue&type=template&id=90026b08&scoped=true&"
import script from "./RuleHistory.vue?vue&type=script&lang=js&"
export * from "./RuleHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90026b08",
  null
  
)

export default component.exports